import React, { Component } from 'react';
import service from '../../core/service';
import { AppConstants } from '../../core/constants';
import * as yup from 'yup'
import { toast } from 'react-toastify';
import { userData } from '../../Redux/services/generalService';

interface IProps {
  dispatch?:any,
  userData?:any
  headerStatus?:boolean
 }

interface IState {
    unEditable?:boolean;
    loading:boolean;
    loadingUpdate:boolean;
    userData:any;
    shebaNumber:string;
    error:Array<any>
}
 class ProfileController extends Component<IProps, IState> {
    ref:any;
    
    constructor(props: any) {
         super(props);
        this.ref = React.createRef();

       
     }
     state : IState = {
      unEditable:true,
      loading:false,
      loadingUpdate:false,
      userData:{},
      shebaNumber:"",
      error:[]
  };
    setShabaNumber = (value:string) => {
        this.setState({ shebaNumber: value })
    }

      
    getContrant = async (hasHeader?:boolean) => {
        try {
          const response = await service.User.contrant(hasHeader);
          if (response) {
            window.open(
              `${AppConstants.base_url_download}${response.data?.data}`,
              '_blank' 
            );
            // return response;
          }
        } catch (error) {
          // throw error;
        }
    };
      
      async updateSheba() {
        const { shebaNumber } = this.state;
        const shebaCodeSchema = yup.object({
          shebaNumber: yup.string().min(24, " شماره شبا 24 کاراکتر می باشد ").max(24, " شماره شبا 24 کاراکتر می باشد " ),
        });
        try {
          this.setState({loading:true})
          await shebaCodeSchema.validate({ shebaNumber }, { abortEarly: false });

          const response = await service.User.sheba(shebaNumber); 

          if (response) {
            this.setState({ loading: false })
            this.setState({ unEditable: !this.state.unEditable , error: [] ,  loading: false})
            toast.info(response?.data?.message);
            this.getProfile()
          }else{
            this.setState({ loading: false })
          }
        } catch (err: any) {
          this.setState({ loading: false })
          this.setState({ error: err.inner })
        }
      };

      async getProfile () {
        return async  (dispatch: any) => {
            try {
                const response = await service.User.profile();
                if (response) {
                    dispatch(userData(response?.data?.data));
                    this.setState({loading:false});
                }
            } catch (error: any) {
              this.setState({loading:false});
              if (error && error.status === 404) {
                window.location.href = '/agent-sign-up'
            }
            }
        };
    };

}
export default ProfileController;